import { useState, ReactElement, useEffect } from "react";
import { Dismiss24Regular } from "@fluentui/react-icons";
import {
  GenericOverviewContent,
  RegisOverviewContent,
  StorageImsOverviewContent
} from "./";

import { useUseCase } from "../../../context/UseCaseContext/UseCaseContext";
import { CorpusListDisplay } from "../CorpusListDisplay";
// Import the unified static list
import { StaticAnswerModes } from "../../answer-modes/AnswerModeContainer/AnswerMode";
import styles from "./UsecaseOverview.module.css";

const UsecaseOverviewPopUp = ({
  dismissContentOverview,
}: {
  dismissContentOverview: () => void;
}) => {
  const { selectedUseCase } = useUseCase();
  const [overviewContent, setOverviewContent] = useState<ReactElement>();
  const [showCorpus, setShowCorpus] = useState<boolean>(false);

  useEffect(() => {
    // We now pass the single unified list.
    // We filter out 'standard' if you want to keep it as a 'ghost' even in the documentation.
    const visibleStaticModes = StaticAnswerModes.filter(
      (m) => m.id !== "standard",
    );

    if (selectedUseCase === "GENERIC") {
      // Updated props to reflect the new unified data structure
      setOverviewContent(
        <GenericOverviewContent availableModes={visibleStaticModes} />,
      );
      setShowCorpus(false);
    } else if (selectedUseCase === "REGIS") {
      setOverviewContent(<RegisOverviewContent />);
      setShowCorpus(true);
    } else if (selectedUseCase === "STORAGE_IMS") {
      setOverviewContent(<StorageImsOverviewContent />);
      setShowCorpus(false);
    } else {
      setOverviewContent(undefined);
      setShowCorpus(false);
    }
  }, [selectedUseCase]);

  return (
    <>
      <div className={styles.overlay} onClick={dismissContentOverview} />
      <div className={styles.popup}>
        <div className={styles.popupHeader}>
          <button
            className={styles.dismissButton}
            onClick={dismissContentOverview}
          >
            <Dismiss24Regular />
          </button>
        </div>
        <div className={styles.popupContent}>
          {overviewContent}
          {showCorpus && <CorpusListDisplay />}
        </div>
      </div>
    </>
  );
};

export default UsecaseOverviewPopUp;
